import { useEffect } from "react";
import { Form, Typography, Image, Alert, message } from "antd";
import Logo from "../../assets/images/auth-logo.png";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton/Button";
import CustomInput from "../../components/CustomInput/Input";
import { clearAuthError, recoverPassword } from "../../redux/slices/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { emailRules } from "../../helpers/helpers";
import { BTN_TXT, DESC_TXT, GLOBAL_CONSTANTS } from "../../constants/constants";

const { Title, Text } = Typography;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    return () => {
      dispatch(clearAuthError());
    };
  }, [dispatch]);

  const onFinish = async (values) => {
    // The server decides between resending the onboarding password and starting
    // the OTP reset, so the client never has to probe account state first.
    const res = await dispatch(recoverPassword(values.email));
    if (res.meta.requestStatus !== "fulfilled") {
      if (typeof res.payload === "string") {
        message.error(res.payload);
      }
      return;
    }

    if (res.payload?.mode === "RESEND") {
      message.success(res.payload?.message || "Password sent successfully!");
      navigate("/login");
      return;
    }

    navigate("/otp", {
      state: { email: values.email, messageId: res.payload?.messageId },
    });
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-logo-container">
        <Image preview={false} src={Logo} alt="Logo" />
      </div>
      <div className="forgot-password-card-container">
        <Title level={2}>{GLOBAL_CONSTANTS.RECOVER_PWD}</Title>
        <Text>
          {DESC_TXT.RECOVER_PWD_INFO_TEXT}
        </Text>
        <Form
          layout="vertical"
          className="forgot-form"
          onFinish={onFinish}
          initialValues={{ remember: true }}
        >
          <CustomInput
            label="Email"
            name="email"
            placeholder="Your Email"
            rules={emailRules("")}
          />

          {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}

          <Form.Item>
            <CustomButton
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ marginTop: 30, padding: 24 }}
            >
              {BTN_TXT.SUBMIT}
            </CustomButton>
          </Form.Item>
          <Form.Item>
            <CustomButton
              type="text"
              block
              style={{ fontWeight: 600, padding: 0 }}
              onClick={() => navigate("/login")}
            >
              {BTN_TXT.BACK}
            </CustomButton>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
